export default __webpack_public_path__ + "locales/ro/FormGallery.json?hash=69c5389ca50872303ba01e44829bcc0c";